﻿import { Grid, TextField} from "@mui/material";
import { useFormActions, useScopedField } from "@ngt/forms-core";
import { FC, useEffect, useState } from "react";
import * as Dtos from '../../api/dtos';

const AdminPaymentDisplay : FC = () => {
    const {state: {value: cost}} = useScopedField<number>("cost", {value: true});
    const { subscribe, getValue } = useFormActions();
    const columnMapping = {
        xs: 12,
        sm: 6,
        md: 4
    }
    //var amountPaid = 0;
    //var owing = 0;

    const [amountPaid, setAmountPaid] = useState(0);
    const [amountOwing, setAmountOwing] = useState(0);

    useEffect(() => {
        const getAmountPaid = (registration: Dtos.Registration) => registration.payments?.reduce((paid,p) => {
            if(p.paymentOption == 8){
                return paid - (p.amountPaid ?? 0);
            }
            else{
                return paid + (p.amountPaid ?? 0);
            }
        }, 0) ?? 0;

        const getAmountOwing = (registration: Dtos.Registration) => registration.payments?.reduce((owing,p) => {
            if(p.paymentOption == 8){
                return owing + (p.amountPaid ?? 0);
            }
            else{
                return owing - (p.amountPaid ?? 0);
            }
        }, registration.cost ?? 0) ?? registration.cost ?? 0;

        const value = getValue();

        setAmountOwing(getAmountOwing(value));
        setAmountPaid(getAmountPaid(value));

        const unsubscribe = subscribe((formState) => {
            setAmountOwing(getAmountOwing(formState.value));
            setAmountPaid(getAmountPaid(formState.value));
        }, {
            value: true
        });

        return () => {
            unsubscribe();
        }
    }, [setAmountPaid, setAmountOwing, subscribe, getValue ]);

    return(
    <>
       <Grid item {...columnMapping}>
            <TextField
                label="Amount Due"
                variant="standard"
                sx={{
                    width: "100%",
                    my: 1,
                }}
                InputProps={{
                    readOnly: true,
                }}
                value={`$${cost ? cost.toFixed(2) : 0}`}
            />
        </Grid>
        <Grid item {...columnMapping}>
            <TextField
                label="Amount Paid"
                variant="standard"
                sx={{
                    width: "100%",
                    my: 1,
                }}
                InputProps={{
                    readOnly: true,
                }}
                value={`$${amountPaid.toFixed(2) ?? 0}`}
            />
        </Grid>
        <Grid item {...columnMapping}>
            <TextField
                label="Amount Owing"
                variant="standard"
                sx={{
                    width: "100%",
                    my: 1,
                }}
                InputProps={{
                    readOnly: true,
                }}
                value={`$${amountOwing.toFixed(2) ?? 0}`}
            />
        </Grid>
    </>
    )
}

export default AdminPaymentDisplay; 